import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Navigation from './Navigation/index.js';
const RightBar = ({ navCSSClass }) => (_jsx(Navigation, { ignoreCSSClass: navCSSClass }));
export default RightBar;
//# sourceMappingURL=index.js.map